module.exports = require('./dist/core');



//////////////////
// WEBPACK FOOTER
// ./~/leancloud-realtime/core.js
// module id = 252
// module chunks = 0